<script setup>
import { ref, computed } from 'vue';
import { useStore } from "vuex";
import SearchField from 'shared/components/product/searchField.vue';
import AutoSuggest from 'shared/components/product/autoSuggest.vue';
import ProductListCardsSkeleton from 'shared/components/product/skeletons/productListCardsSkeleton.vue';
import useProductList from 'shared/components/product/composables/useProductList.js';
import useProductListLabels from 'shared/components/product/composables/useProductListLabels.js';

const store = useStore();
const productList = useProductList();
const { labels } = useProductListLabels();

const selectedIndex = ref(-1);
const down = () => {
	selectedIndex.value += 1;
}
const up = () => {
	selectedIndex.value -= 1;
}

const didYouMeanSearch = (searchTerm) => {
	store.commit('setSearchTerm', searchTerm);
	productList.autoSuggestSearch({ term: searchTerm });
}

const noAutocompleteItems = computed(() => {
	const suggestions = productList.suggestions.value.length > 0;
	const term = productList.searchTerm.value

	return !suggestions && term.length > 2 && (term !== productList.keyWordSearchInProgress.value);
});


</script>

<template>
	<search-field
		:isProductPage="true"
		:placeholder="labels.searchPlaceholderText.value"
		v-on:search="productList.handleSearch"
		v-on:reset="productList.resetSuggestions"
		v-on:autosuggestsearch="productList.autoSuggestSearch"
		:expanded="!!productList.suggestions.value?.length"
		@down="down"
		@up="up"
	>
		<ProductListCardsSkeleton
			v-if="productList.isSearching.value && productList.term.value"
			class="c-search__auto-suggest c-search__auto-suggest--product-page"
			:items="4"
			img-width="100"
			:separator="true"
		/>
		<auto-suggest
			v-else
			:is-product-page="true"
			:suggestions="productList.suggestions.value"
			:selected-index="productList.selectedSuggestionIndex.value"
			:property-group-delimiter="
				productList.suggestionPropertyGroupDelimiter.value
			"
			:ecommerce-tracking-data="
				productList.suggestionsEcommerceTrackingData.value
			"
			:tracking-enabled="true"
			:noAutocompleteItems="noAutocompleteItems"
			:is-loading="productList.autoSuggestInProgress.value"
			:did-you-mean-items="productList.didYouMeanItems.value"
			@didYouMeanSearch="didYouMeanSearch"
		>
		</auto-suggest>
	</search-field>
</template>
